import { Outlet } from "react-router-dom";
import { Footer } from "../components";
import MainNav from "../components/Nav/nav.component";

export default function Root() {
  return (
    <>
      <div id="main-content">
        <Outlet></Outlet>
      </div>
      <Footer></Footer>
    </>
  );
}
